module.exports = __webpack_public_path__ + "img/3_62.cbea93cc.png";